export const EmailTemplateCategoryEnum = {
  ELECTRIC_AND_WATER_INVOICE: 1,
  MANAGEMENT_SERVICE: 2,
}
// Reference NotificationCategoryEnum
export default EmailTemplateCategoryEnum


// WEBPACK FOOTER //
// ./src/enum/emailTemplateCategoryEnum.js